<mat-form-field [appearance]="appearance" style="width: 100%">
   <mat-icon *ngIf="showIcon" matPrefix svgIcon="barcode_24"></mat-icon>
   <mat-label style="text-transform: capitalize">{{name}}</mat-label>
   <input matInput type="text" autocomplete="off" #search
          [placeholder]="placeholder" onfocus="this.select()"
          [(ngModel)]="barcode" (ngModelChange)="barcode = $event.toUpperCase()"
          [formControl]="inputCtrl" (keydown.enter)="searchValues()">
</mat-form-field>
